module.exports = __webpack_public_path__ + "assets/img/PREVENTA_img1.2ad6ae68.png";